import { api_host, default_environment } from '../AppConf';
require('whatwg-fetch');

class WeatherService {
  constructor(configOptions, revieveConfig){
    this.configOptions = configOptions;
    this.revieveConfig = revieveConfig;
    this.info = {};
    this.filter = {};
  }

  setInfo(info) {
    this.info = info;
  }

  getInfo() {
    return this.info;
  }

  setFilters(filters) {
    this.filters = filters;
  }

  doGeoIP(){
    return new Promise((resolve, reject) => {
      fetch(api_host[this.revieveConfig.environment || default_environment]+'/api/functions/geoIp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Parse-Application-Id': 'Revieve API'
        },
        body: JSON.stringify(this.filters)
      })
      .then(function(response) {
        return response.json();
      })
      .then((body) => {
        let defaultDisplay = body.result.city ? body.result.city : body.result.country;
        let display = this.configOptions.results && this.configOptions.results.geoDisplayLevel && body.result.hasOwnProperty(this.configOptions.results.geoDisplayLevel) ? body.result[this.configOptions.results.geoDisplayLevel] : defaultDisplay;
        let obj = {city: body.result.city, country: body.result.country, area: body.result.area, display: display};
        this.info = obj;
        resolve(this.info);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
    });
  }

  getWeather() {
    return new Promise((resolve, reject) => {
      try {
        fetch(api_host[this.revieveConfig.environment || default_environment]+'/api/functions/weather', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Parse-Application-Id': 'Revieve API'
          },
          body: JSON.stringify(this.info)
        })
        .then(function(response) {
          return response.json();
        })
        .then((body) => {
          this.info = Object.assign({}, this.info, body.result);
          resolve(this.info);
        })
        .catch((err) => {
          console.error(err);
          reject(err);
        });
      } catch(e) {
        console.log(e);
        reject(e);
      }
    });    
  }
}

export default WeatherService;


// WEBPACK FOOTER //
// ./src/services/Weather.js